const translations = {
  app: {
    title: "MobyPro",
    slogan: "Welcome to MobyPro",
  },
  common: {
    dashboard: "Dashboard",
    newRepair: "New Repair",
    search: "Search",
    stock: "Stock & POS",
    searchRepairs: "Search Repairs",
    viewDetails: "View Details",
    clickToView: "Click to view",
    processing: "Processing...",
    submit: "Submit",
    cancel: "Cancel",
    delete: "Delete",
    optional: "optional",
    areYouSure: "Are you sure?",
    back: "Back to",
    loading: "Loading...",
    print: "Print",
    download: "Download",
    balance: "Balance",
    error: "Error!",
    pageNotFound: "Oops! Page not found",
    returnHome: "Return to Home",
    copied: "Copied to clipboard",
    call: "Call",
    startScanning: "Start Scanning",
    stopScanning: "Stop Scanning",
    scannerActive: "Scanner is active and ready",
    scannerInactive: "Scanner is inactive",
    logo: "Logo",
    repairShop: "Repair Shop",
    tel: "Tel",
    phone: "Phone",
    clear: "Clear",
    edit: "Edit",
    disabled: "Disabled",
    featureDisabledMessage: "This feature has been disabled for this store.",
    enterSecurityCode: "Enter security code",
    invalidSecurityCode: "Invalid security code. Please try again.",
  },
  repair: {
    createNew: "Create New Repair",
    customerInfo: "Customer Details",
    customerName: "Customer Name",
    customerPhone: "Phone Number",
    customerEmail: "Customer Email",
    phoneModel: "Device Model",
    stat: "Status",
    problemDescription: "Problem Description",
    observations: "Observations",
    observationsOptional: "(optional)",
    addObservation: "Add observation",
    noObservations: "No observations yet",
    observationAdded: "Observation added successfully",
    observationAddError: "Failed to add observation",
    repairPrice: "Repair Price",
    initialPrice: "Initial Price",
    totalPrice: "Total Price",
    paymentStatus: "Payment Status",
    downPayment: "Down Payment",
    priceModifications: "Price Modifications",
    priceModified: "Price has been modified",
    addPriceModification: "Add Price Modification",
    priceModificationAdded: "Price modification added successfully",
    priceModificationAddError: "Failed to add price modification",
    amount: "Amount",
    reason: "Reason",
    submitRepair: "Submit Repair",
    repairDetails: "Repair Details",
    repairTimeline: "Repair Timeline",
    statusChanged: "Status changed to",
    updateStatus: "Update Status",
    deleteRepair: "Delete Repair",
    deleteConfirmation:
      "Are you sure you want to delete this repair? This action cannot be undone.",
    enterDeleteCode: "Enter deletion code",
    invalidDeleteCode: "Invalid deletion code. Please try again.",
    successCreated: "Repair created successfully!",
    failedCreated: "Failed to create repair!",
    successUpdated: "Repair updated successfully!",
    successDeleted: "Repair deleted successfully!",
    notFound: "Repair not found",
    active: "Active",
    completed: "Completed",
    returned: "Returned",
    all: "All",
    noActiveRepairs: "No active repairs found",
    noCompletedRepairs: "No completed repairs found",
    noReturnedRepairs: "No returned repairs found",
    noRepairsFound: "No repairs found",
    createFirstRepair: "Create your first repair",
    addedAgo: "Added {{time}}",
    scanQrCode: "Scan this QR code to view repair details",
    scanQrCodeToTrack: "Track your repair on the Talifouni app",
    scanBarcode: "Scan this barcode with 1D scanner",
    barcodeSticker: "Barcode Sticker",
    repairTicket: "Repair Ticket",
    ticketNumber: "Ticket Number",
    qrCode: "QR Code",
    selectCodeType: "Select Code Type",
    selectCodeTypeDescription:
      "Choose which type of code to include on the printed ticket",
    repairNumber: "Repair Number",
    thankYou: "Thank you for your business!",
    bringReceipt: "Please bring this receipt when you pick up your device.",
    printTicket: "Print Ticket",
    status: {
      pending: "Pending",
      inProgress: "In Progress",
      completed: "Completed",
      returned: "Returned",
      cancelled: "Cancelled",
    },
    payment: {
      paid: "Paid",
      partial: "Partial",
      unpaid: "Unpaid",
    },
    addError: "Failed to add repair. Please try again.",
    fetchError: "Failed to fetch repairs. Please try again.",
    updateError: "Failed to update repair. Please try again.",
    deleteError: "Failed to delete repair. Please try again.",
    importError: "Failed to import repairs. Please try again.",
    noRepairFoundWithTicket:
      "No repair found with this ticket number. Please check and try again.",
    noTicketNumberForBarcode:
      "No ticket number available for barcode generation.",

    // Email notifications
    sendEmail: "Send Email",
    sendEmailToCustomer: "Send Email to Customer",
    emailSentSuccess: "Email sent successfully",
    emailSentError: "Failed to send email",
    invalidEmailAddress: "Invalid email address",
    emailTemplate: "Email Template",
    completionTemplate: "Repair Completion",
    customTemplate: "Custom Message",
    emailSubject: "Subject",
    emailMessage: "Message",
    enterEmailSubject: "Enter email subject",
    enterEmailMessage: "Enter your message to the customer",
    showPreview: "Show Preview",
    hidePreview: "Hide Preview",
    emailPreview: "Email Preview",
    to: "To",
    subject: "Subject",
    sending: "Sending...",
  },
  searchRepairs: {
    title: "Search Repairs",
    noResults: "No repairs found",
    adjustFilters: "Try adjusting your search or filters",
  },
  filters: {
    title: "Filters",
    slogan: "Filter repairs by status and payment",
    status: "Status",
    payment: "Payment Status",
    clear: "Clear filters",
    anyStatus: "Any status",
    anyPaymentStatus: "Any payment status",
    clearAll: "Clear all filters",
    dateFrom: "From Date",
    dateTo: "To Date",
  },
  importExport: {
    import: "Import",
    export: "Export",
    importRepairs: "Import Repairs",
    exportRepairs: "Export Repairs",
    chooseFile: "Choose File",
    downloadTemplate: "Download Template",
    importedSuccess: "Repairs imported successfully!",
    exportedSuccess: "Repairs exported successfully!",
    invalidFile: "Invalid file format. Please use a valid JSON file.",
    importConfirmation:
      "Are you sure you want to import these repairs? This will overwrite any existing data.",
  },
  analytics: {
    title: "Payment Analytics",
    totalAmountPaid: "Total Amount Paid",
    averageAmountPaid: "Average Amount Paid",
    monthlyRevenue: "Monthly Revenue",
  },
  auth: {
    login: "Login",
    logout: "Logout",
    email: "Email",
    password: "Password",
    loginToContinue: "Login to continue to your account",
    genericError: "An error occurred during login",
    emailRequired: "Email is required",
    passwordRequired: "Password is required",
    invalidCredentials: "Invalid email or password",
  },
  languageSwitcher: {
    language: "Language",
    english: "English",
    french: "French",
    arabic: "Arabic",
  },
  repairShop: {
    title: "Repair Shop",
    name: "Shop Name",
    address: "Address",
    phone: "Phone",
    fetchError: "Failed to fetch repair shop information",
  },
  scanner: {
    henexScanner: "Dedicated Scanner",
    cameraScanner: "Camera Scanner",
    barcode: "Barcode",
    henexInstructions:
      "Dedicated scanner is active. Scan a barcode or QR code directly.",
    scannerInstructions: "Press the scanner button to scan a code",
    scanPlaceholder: "Scan a code...",
    scanSuccess: "Code scanned successfully!",
    scanError: "Error scanning code. Please try again.",
    autoScanEnabled: "Auto-scanning enabled",
    readyToScan: "Ready to scan",
    scanningActive: "Scanner active",
  },
  shortcuts: {
    title: "Keyboard Shortcuts",
    description: "Use these keyboard shortcuts to navigate quickly",
    keyboard: "Shortcuts",
    showShortcuts: "Show keyboard shortcuts",
    tip: "Press ? anytime to show this help dialog",
    goToDashboard: "Go to Dashboard (Alt+H)",
    newRepair: "Create New Repair (Alt+N)",
    printCurrentRepair: "Print Current Repair (Alt+P)",
    help: "Show Keyboard Shortcuts (?)",
    navigatedToDashboard: "Navigated to Dashboard",
    creatingNewRepair: "Creating new repair",
    printing: "Printing...",
  },
  theme: {
    light: "Light",
    dark: "Dark",
    system: "System",
    toggleDarkMode: "Toggle dark mode",
  },
  dashboard: {
    title: "Dashboard",
    editLayout: "Edit Layout",
    saveLayout: "Save Layout",
    reset: "Reset",
    addWidget: "Add Widget",
    widgetAdded: "Widget added successfully",
    widgetRemoved: "Widget removed",
    dashboardReset: "Dashboard reset to default",
    widgetType: "Widget Type",
    widgetTitle: "Widget Title",
    selectWidgetType: "Select widget type",
    addWidgetDescription: "Choose a widget type and customize its title",
    totalRepairs: "Total Repairs",
    repairs: "Repairs",
    noRepairsFound: "No repairs found",
    unknownDevice: "Unknown Device",
    goodMorning: "Good Morning",
    goodAfternoon: "Good Afternoon",
    goodEvening: "Good Evening",
    user: "User",
    welcomeMessage:
      "Welcome to your personalized dashboard. Here you can see an overview of your repair shop.",
    widgets: {
      welcome: {
        title: "Welcome",
        defaultTitle: "Welcome",
      },
      "repair-status": {
        title: "Repair Status",
        defaultTitle: "Repair Status",
      },
      "recent-repairs": {
        title: "Recent Repairs",
        defaultTitle: "Recent Repairs",
      },
      "repairs-by-status": {
        title: "Repairs by Status",
        defaultTitle: "Repairs by Status",
      },
      "repairs-by-device": {
        title: "Repairs by Device",
        defaultTitle: "Repairs by Device",
      },
      "payment-status": {
        title: "Payment Status",
        defaultTitle: "Payment Status",
      },
      income: {
        title: "Income",
        defaultTitle: "Income",
      },
    },
    paid: "Paid",
    unpaid: "Unpaid",
    partial: "Partially Paid",
    noPaymentData: "No payment data available",
    monthlyIncome: "Monthly Income",
    totalIncome: "Total Income",
    income: "Income",
    increase: "increase",
    decrease: "decrease",
    allTime: "All time",
  },
  stock: {
    title: "Stock Management & POS",
    pos: "Point of Sale",
    allCategories: "All Categories",
    products: "Products",
    categories: "Categories",
    sales: "Sales",
    inventory: "Inventory",
    reports: "Reports",

    // Product Management
    addProduct: "Add Product",
    editProduct: "Edit Product",
    deleteProduct: "Delete Product",
    productName: "Product Name",
    productDescription: "Description",
    sku: "SKU",
    barcode: "Barcode",
    category: "Category",
    price: "Price",
    cost: "Cost",
    stock: "Stock",
    minStock: "Min Stock",
    maxStock: "Max Stock",
    isActive: "Active",
    image: "Image",

    // Categories
    addCategory: "Add Category",
    editCategory: "Edit Category",
    categoryName: "Category Name",
    categoryDescription: "Category Description",

    // POS Interface
    cart: "Cart",
    addToCart: "Add to Cart",
    removeFromCart: "Remove",
    clearCart: "Clear Cart",
    quantity: "Quantity",
    unitPrice: "Unit Price",
    discount: "Discount",
    subtotal: "Subtotal",
    tax: "Tax",
    total: "Total",

    // Payment
    payment: "Payment",
    paymentMethod: "Payment Method",
    cash: "Cash",
    card: "Card",
    mobile: "Mobile Payment",
    mixed: "Mixed Payment",
    amountPaid: "Amount Paid",
    change: "Change",
    processSale: "Process Sale",

    // Customer
    customer: "Customer",
    customerName: "Customer Name",
    customerPhone: "Customer Phone",

    // Sales
    saleNumber: "Sale #",
    saleDate: "Sale Date",
    saleTotal: "Sale Total",
    viewSale: "View Sale",

    // Inventory
    lowStock: "Low Stock",
    outOfStock: "Out of Stock",
    stockLevel: "Stock Level",
    stockMovement: "Stock Movement",
    stockIn: "Stock In",
    stockOut: "Stock Out",
    adjustment: "Adjustment",

    // Messages
    productAdded: "Product added successfully",
    productUpdated: "Product updated successfully",
    productDeleted: "Product deleted successfully",
    categoryAdded: "Category added successfully",
    categoryUpdated: "Category updated successfully",
    categoryDeleted: "Category deleted successfully",
    saleCompleted: "Sale completed successfully",
    insufficientStock: "Insufficient stock",
    invalidQuantity: "Invalid quantity",
    fetchError: "Error fetching data",
    addError: "Error adding item",
    updateError: "Error updating item",
    deleteError: "Error deleting item",
    saleError: "Error processing sale",
    stockAdjusted: "Stock adjusted successfully",
    adjustError: "Error adjusting stock",

    // Touch Interface
    touchMode: "Touch Mode",
    gridView: "Grid View",
    listView: "List View",
    searchProducts: "Search products...",

    // Barcode Scanner
    scan: "Scan",
    scanBarcode: "Scan Barcode",
    barcodeScanner: "Barcode Scanner",
    manualEntry: "Manual Entry",
    cameraScanner: "Camera Scanner",
    enterBarcode: "Enter Barcode",
    productNotFound: "Product not found",
    productInactive: "Product is inactive",
    productOutOfStock: "Product is out of stock",
    barcodeAdded: "Product added to cart via barcode",
    scannerActive: "Scanner Active - Ready to scan",
    scanning: "Scanning",
    scannerInstructions: "Automatic barcode scanning is active:",
    useBarcodeScannerDevice: "Use barcode scanner",
    typeBarcodeDirect: "Type barcode directly",
    automaticCartAdd: "Auto-adds to cart",
    cameraStarted: "Camera started. Point at barcode to scan.",
    cameraError: "Could not access camera. Please use manual input.",
    enterBarcodeManually: "Enter Barcode Manually",
    enterOrScanBarcode: "Enter or scan barcode...",
    pointCameraAtBarcode: "Point camera at barcode to scan",
    orTypeBarcodeHere: "Or type barcode here...",
    cameraNotStarted: "Camera not started",
    startCamera: "Start Camera",

    // Sales Ticket & Printing
    salesTicket: "Sales Ticket",
    printTicket: "Print Ticket",
    print: "Print",
    thankYouVisit: "Thank you for your visit!",
    keepTicket: "Please keep this ticket for your records",
    printInstructions1: "Optimized for 80mm thermal printers",
    printInstructions2: "Ensure printer is connected and ready",
    printInstructions3: "Click Print to generate receipt",

    // Sales History
    todaysSales: "Today's Sales",
    todaysRevenue: "Today's Revenue",
    totalSales: "Total Sales",
    noSalesYet: "No sales yet",
    walkInCustomer: "Walk-in Customer",
    saleId: "Sale ID",
    totalValue: "Total Value",
    noLowStockItems: "No low stock items",
    noOutOfStockItems: "No out of stock items",

    // Empty States
    emptyCart: {
      title: "Your cart is empty",
      subtitle: "Add products to get started",
      action: "Browse Products",
      tip: "Scan a barcode or click on products to add them",
    },
    emptyProducts: {
      title: "No products found",
      subtitle: "Try adjusting your search or category filter",
      action: "Clear Filters",
      tip: "Make sure products are added to your inventory",
    },

    // Daily Summary
    dailySummary: "Daily Summary",
    totalRevenue: "Total Revenue",
    transactions: "Transactions",
    avgTransaction: "Avg Transaction",
    itemsSold: "Items Sold",
    paymentBreakdown: "Payment Methods",
    peakHour: "Peak Hour",
    printSummary: "Print Summary",
    exportSummary: "Export Summary",
    selectDateRange: "Select Date Range",
    today: "Today",
    yesterday: "Yesterday",
    thisWeek: "This Week",
    thisMonth: "This Month",
    customRange: "Custom Range",
    from: "From",
    to: "To",
    apply: "Apply",


    // Product Management
    showInactive: "Show Inactive",
    hideInactive: "Hide Inactive",
    inactive: "Inactive",

    // Barcode Sticker
    generateSticker: "Generate Sticker",
    printSticker: "Print Sticker",
    generateBarcode: "Generate Barcode",
    generateEAN13Barcode: "Generate EAN13 Barcode",
    barcodeSticker: "Barcode Sticker",
    stickerPreview: "Sticker Preview",
    copies: "Copies",
    productNeedsBarcode: "This product needs a barcode",
    addBarcodeToProduct: "Add a barcode to this product to print stickers",
    downloadSticker: "Download Sticker",
    saveBarcodeToProduct: "Save Barcode to Product",
    barcodeGenerated: "Barcode generated successfully",
    barcodeSaved: "Barcode saved to product successfully",
    noBarcodeToSave: "No barcode to save",
    failedToGenerateBarcode: "Failed to generate barcode",
    failedToSaveBarcode: "Failed to save barcode to product",
    productHasBarcode: "Has Barcode",
    productNoBarcode: "No Barcode",
    generateNewBarcode:
      "This product doesn't have a barcode. Generate one below.",
    tryAdjustingSearch: "Try adjusting your search terms",
    getStartedAddProduct: "Get started by adding your first product",

    // POS Interface Messages
    cartIsEmpty: "Cart is empty",
    insufficientPayment: "Insufficient payment amount",
    saleFailed: "Sale failed",
    unknownError: "Unknown error",
    saleProcessedSuccessfully: "Sale processed successfully!",

    // Quick Setup
    userOrShopNotFound: "User or repair shop not found",
    errorCheckingSetup: "Error checking setup",
    errorCreatingSampleData: "Error creating sample data",
    sampleDataCreatedSuccessfully: "Sample data created successfully!",
    checking: "Checking...",
    checkSetup: "Check Setup",
    createSampleData: "Create Sample Data",

    // Product Form
    priceAndCostMustBePositive: "Price and cost must be positive numbers",
    enterProductName: "Enter product name",
    enterSKU: "Enter SKU",
    enterProductDescription: "Enter product description",

    // Stock Validation Messages
    productNoLongerExists: "Product no longer exists",
    productNoLongerActive: "Product is no longer active",
    insufficientStockDetailed:
      "Insufficient stock for {{productName}}. Available: {{available}}, Required: {{required}}",

    // Advanced POS Features
    holdOrder: "Hold Order",
    heldOrders: "Held Orders",
    recallOrder: "Recall Order",
    deleteOrder: "Delete Order",
    orderHeld: "Order held successfully",
    orderRecalled: "Order recalled successfully",
    orderDeleted: "Order deleted successfully",
    applyDiscount: "Apply Discount",
    orderDiscount: "Order Discount",
    itemDiscount: "Item Discount",
    discountType: "Discount Type",
    percentage: "Percentage",
    fixedAmount: "Fixed Amount",
    discountValue: "Discount Value",
    discountApplied: "Discount applied successfully",
    notes: "Notes",
    addNotes: "Add Notes",
    orderNotes: "Order Notes",
    noHeldOrders: "No held orders",
    heldOn: "Held on",
    orderTotal: "Order Total",
    discountAmount: "Discount Amount",

    // Password Protection
    confirmProductCreation: "Confirm Product Creation",
    confirmProductUpdate: "Confirm Product Update",
    confirmProductDeletion: "Confirm Product Deletion",
    confirmCategoryCreation: "Confirm Category Creation",
    confirmCategoryUpdate: "Confirm Category Update",
    confirmCategoryDeletion: "Confirm Category Deletion",
    productCreationWarning:
      "This action will create a new product in your inventory. Please enter the access code to continue.",
    productUpdateWarning:
      "This action will modify an existing product in your inventory. Please enter the access code to continue.",
    productDeletionWarning:
      "This action will permanently delete the product from your inventory. This cannot be undone. Please enter the access code to continue.",
    categoryCreationWarning:
      "This action will create a new category in your inventory. Please enter the access code to continue.",
    categoryUpdateWarning:
      "This action will modify an existing category in your inventory. Please enter the access code to continue.",
    categoryDeletionWarning:
      "This action will permanently delete the category from your inventory. This cannot be undone. Please enter the access code to continue.",
    updateProduct: "Update Product",
    updateCategory: "Update Category",
    deleteCategory: "Delete Category",
    cannotDeleteCategory:
      "Cannot delete category. It contains {{count}} products. Please move or delete the products first.",
    
    // Sales Return
    returnSale: "Return Sale",
    processReturn: "Process Return",
    confirmReturn: "Confirm Return",
    saleReturned: "Sale returned successfully",
    returnError: "Error returning sale",
    saleAlreadyReturned: "Sale already returned",
    saleNotFound: "Sale not found",
    returned: "Returned",
    
    // Cost Visibility
    hideCosts: "Hide Costs",
    showCosts: "Show Costs",
    unlockCost: "Unlock Cost",
    costLocked: "Cost Locked",
  },
};

export default translations;
